import "./../css/sass/styles.scss";

import { debouncer, documentReady, scrollToEl } from "./Utility/utils";
import "./components/slider";
import "./components/video";
import "./components/accordion";
import "./components/main-navigation";
import "./components/language-bar";
import "./components/custom-popup";
import "./components/custom-lightbox";